const moduleB = {
	state: {
		moduleCountB: 'bbbbbbbbbb'
	},
	mutations: {},
	actions: {},
	getters: {}
}
export default moduleB



// WEBPACK FOOTER //
// ./src/store/modules/moduleB.js